import apiClient from "./client";
import type {
  TenantMutationResponse,
  UpdateTenantOptions,
  UpdateTenantPayload,
} from "../types/tenant";

export const updateTenant = async (
  data: UpdateTenantPayload,
  options: UpdateTenantOptions = {}
): Promise<TenantMutationResponse> => {
  const config: { params?: { id: number } } = {};
  if (options.id) {
    config.params = { id: options.id };
  }
  const { data: response } = await apiClient.put<TenantMutationResponse>(
    "/tenant",
    data,
    config
  );
  return response;
};

export const deleteTenant = async (
  tenantId: number | string
): Promise<TenantMutationResponse> => {
  const { data } = await apiClient.delete<TenantMutationResponse>("/tenant", {
    params: { id: tenantId },
  });
  return data;
};
